var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinearAt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.578 21.625c1.324 0 2.602-.176 3.574-.48V19.41c-.68.281-2.074.469-3.457.469-4.992 0-8.168-3.094-8.168-7.945v-.024c0-4.758 3.2-8.11 7.746-8.11 4.536 0 7.57 2.825 7.57 7.044v.023c0 2.578-.82 4.242-2.12 4.242-.762 0-1.196-.492-1.196-1.312V7.305h-2.144V8.71h-.211c-.457-1.031-1.488-1.652-2.73-1.652-2.368 0-3.997 1.957-3.997 4.793v.023c0 2.965 1.63 4.957 4.067 4.957 1.36 0 2.355-.645 2.847-1.828h.211l.012.07c.234 1.102 1.29 1.817 2.695 1.817 2.79 0 4.536-2.368 4.536-6.118v-.023c0-5.133-3.844-8.672-9.434-8.672-5.824 0-9.82 3.985-9.82 9.762v.023c0 5.918 3.937 9.762 10.02 9.762zm-.61-6.773c-1.335 0-2.155-1.102-2.155-2.907v-.023c0-1.828.808-2.918 2.167-2.918 1.383 0 2.25 1.125 2.25 2.918v.023c0 1.782-.878 2.907-2.261 2.907z",
    fill: "#C5CEE0",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinearAt);
export default __webpack_public_path__ + "static/media/icon-linear-at.85ff01b0.svg";
export { ForwardRef as ReactComponent };